module.exports = "/images/jonkoping_energi_ab.png?29db406744c7cc3b2fd63d121be45b08";